<template>
  <v-app>
    <v-container fluid>
      <v-row class="text-center">
        <v-col cols="12">
          <h1>Single Point Long History Data Health</h1>
          <router-link to="/" class="new-page-button">Go to Home Page</router-link>
        </v-col>
      </v-row>
      <v-row justify='space-between'>
      </v-row>
      <h1 v-if="loading">Loading...</h1>
      <div v-else class="flex-container">
        <div class="flex-item">
          <input type="text" v-model="searchInput" placeholder="Type here to filter!" class="input-search">
          <div class="scrollable-container">
            <div 
              v-for="(row, id) in filteredData" 
              :key="id" 
              @click="selectRowGetResult(row)"
              class="row-item"
              :class="{ 'selected-row': selectedRow === row }"
            >
              <div>{{ row['raw-pointName'].slice(0, -5) }}</div>
            </div>
          </div>
        </div>
        <!-- <div v-if="selectedRow">
          <h2>Selected Row:</h2>
          <p>{{ selectedRow }} with result {{ this.result }}</p>
        </div> -->
        <div>
          <apexchart type="radialBar" :options="chartOptions" :series="chartSeries" :width="600" :height="600" />
        </div>
      </div>
    </v-container>
  </v-app>
</template>
  
<script>
  import axios from 'axios'
  import "../assets/styles.css";
  import VueApexCharts from 'vue-apexcharts';
  
  export default {
    components: {
      apexchart: VueApexCharts,
    },
    name: 'App',
    mounted() {
      this.getTable();
    },
  
    data() {
      return{
        tempData: null,
        maxDate: new Date(Date.now()- (1000 * 60 * 60 * 24 * 1)).toISOString(), // makes sure that ineligible dates cannot be selected
        searchInput: '',
        loading: true,
        selectedRow: null,
        result: null,
        test: null,

        chartOptions: {
          plotOptions: {
            radialBar: {
              hollow: {
                size: '60%',
              },
              dataLabels: {
                showOn: 'always',
                value: {
                  offsetY: 8,
                  fontSize: '20px',
                },
              },
            },
          },
          labels: ['Long Term Data Health'],
        },
        chartSeries: [0],
      }
    },
  
    computed: {
      filteredData() {
        return this.tempData.filter(row => row['raw-pointName'].toLowerCase().includes(this.searchInput.toLowerCase()));
      },
    },
  
    methods: {
      async selectRowGetResult(row) {
        this.selectedRow = row;
        let raw = row['raw-endPoint']
        let ingested = row['new-endPoint']
        this.test = await this.getResult(raw, ingested)
        console.log(this.result)
        this.chartSeries = [100 - parseFloat(parseFloat(this.result).toFixed(2))];
      },
      getTable() {
        console.log('Getting Table...')
        let end = new Date();  // Today's date
        let start = new Date(end);
        start.setDate(start.getDate() - 1);  // Yesterday's date
  
        let apiRequest = {
            "how": "wide",
            "startDate" : start.toISOString().slice(0, 10), 
            "endDate" : end.toISOString().slice(0, 10),
            "rollup": "avg",
            "intv": "1hour",
            "table" : 1,
        }
  
        axios.post('https://fm-energywatch.ad.gatech.edu/rbsBackend/ingestVizMain', // changed to real API url. TEST: http://127.0.0.1:5000/ingestVizMain. REAL: https://fm-energywatch.ad.gatech.edu/rbsBackend/ingestVizMain
        apiRequest
        )
        .then((response) => {
          console.log('Got the table!')
            this.tempData = response.data
            this.loading = false
            console.log(this.tempData)
        })
      },

      async getResult(raw, ingested) {

        let end = new Date();  // Today's date
        let start = new Date(end.getFullYear() - 1, end.getMonth(), end.getDate()); // 1 year ago

        let apiRequest = {
            "startDate" : start.toISOString().slice(0, 10), 
            "endDate" : end.toISOString().slice(0, 10),
            "rollup": "avg",
            "intv": "1day",
            "raw": raw,
            "ingested": ingested,
        }

        return axios.post('https://fm-energywatch.ad.gatech.edu/rbsBackend/ingestVizSingle', // changed to real API url. TEST: http://127.0.0.1:5000/ingestVizSingle. REAL: https://fm-energywatch.ad.gatech.edu/rbsBackend/ingestVizSingle
        apiRequest
        )
        .then((response) => {
          this.result = response.data
          console.log(this.result)
          return this.result
        })
      }
    },
  };
  </script>

<style scoped>
.row-item {
  cursor: pointer;
}

.scrollable-container {
  height: 300px;
  overflow: auto;
  border: 1px solid #ccc;
  padding: 10px;
}

.flex-container {
  display: flex;
  justify-content: space-between;
}

.flex-item {
  width: 50%;
}

.apexcharts-data-labels text {
  font-size: 200px !important;
}

.selected-row {
  background-color: #f0f0f0;  /* Change this to the color you want */
}

.input-search {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
}

</style>